import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {OptimizationReport} from '../../../models/optimization-report.model';
import {OptimizationReportService} from '../../../services/optimization-report.service';
import {UtilService} from '../../../services/util.service';
import {UiBlockerService} from '../../../services/ui-blocker.service';
import {map} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class OptimizationReportResolver implements Resolve<Observable<Array<OptimizationReport>>> {

  constructor(private service: OptimizationReportService,
              private utilService: UtilService,
              private uiBlockerService: UiBlockerService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Array<OptimizationReport>> {
    const projectId = this.utilService.getRouteParameter(route, 'projectId');
    const modelRunId = this.utilService.getRouteParameter(route, 'modelRunId');
    this.uiBlockerService.block();
    return this.service.fetchAll(+projectId, modelRunId).pipe(map((reports: OptimizationReport[]) => {
      this.uiBlockerService.unblock();
      return reports;
    }));
  }
}
